import type { FC } from 'react'
import type { CardFeatureIconType } from '../atoms/CardFeatureIcon'
import { CardFeatureIcon } from '../atoms/CardFeatureIcon'

export type ContactDetailListProps = {
	details: CardFeatureIconType[]
}

export const ContactDetailList: FC<ContactDetailListProps> = ({ details }) => {
	return (
		<div className="flex flex-col gap-y-2xl">
			{details.map((detail) => (
				<CardFeatureIcon key={detail.id} card={detail} size="small" />
			))}
		</div>
	)
}

export default ContactDetailList
